/* ==========================================================================
   LALTERNATIVA STYLE - Header non incollato sopra il video hero
   Caricato da snippets/las-global-inline.liquid.

   PROBLEMA: l'header del tema e' position:sticky con top:0, sempre attivo.
   Sulla home il video hero e' alto quasi tutto lo schermo e l'header ci
   resta sopra mentre si scorre, coprendolo.

   COSA FA: solo sulla HOME e solo da 1024px in su, mette la classe
   .las-no-sticky sull'header finche' non si e' scesi sotto la sezione
   "Outfit per ogni occasione". Con quella classe il CSS fa SCIVOLARE VIA
   l'header verso l'alto (transform + transizione di 0,35s), quindi il video
   si vede intero. Sotto la soglia la classe cade e torna il comportamento
   normale del tema (agganciato in alto, riappare risalendo).
   La regola CSS che usa la classe sta in las-global-inline.liquid.

   v2 - PERCHE' NON USIAMO PIU' position:relative: la prima versione
   scambiava sticky <-> relative. Funzionava, ma lo scambio e' istantaneo e
   non e' animabile: risalendo sopra la soglia l'header spariva di colpo.
   Con il transform l'elemento resta sempre sticky e si limita a scorrere
   fuori schermo, quindi l'uscita e il rientro sono morbidi.

   ZONA ALTA: nei primi pixel (fino all'altezza dell'header) la classe NON
   viene messa, altrimenti bastava un dito di scroll per far sparire il menu
   appena aperta la pagina. L'header resta al suo posto e comincia a
   scivolare via solo quando si e' davvero entrati nel video.

   LA SOGLIA e' il bordo inferiore della SECONDA sezione di #MainContent.
   Sulla home l'ordine e': 1) slideshow hero, 2) Outfit per ogni occasione.
   Se riordini le sezioni della homepage la soglia si sposta: ricontrolla qui.

   ATTENZIONE - ERRORE GIA' FATTO UNA VOLTA: la prima versione accodava
   l'aggiornamento con requestAnimationFrame usando una variabile di guardia
   ("ne ho gia' uno in coda, esco"). Se il browser salta il frame - succede
   quando la scheda passa in secondo piano - la guardia resta alzata per
   sempre e da quel momento lo scroll non aggiorna piu' nulla: l'header
   restava staccato anche in fondo alla pagina. Qui il confronto si fa
   direttamente nel gestore dello scroll: e' una sola sottrazione e un
   toggle di classe, non serve accodare niente.
   ========================================================================== */
(function () {
  var LARGHEZZA_MINIMA = 1024;
  var header = document.querySelector('.f-section-header');
  if (!header) return;
  if (!document.body || document.body.className.indexOf('template-index') === -1) return;

  var soglia = 0;

  function calcolaSoglia() {
    var main = document.getElementById('MainContent');
    if (!main) return 0;
    var rif = main.children[1] || main.children[0];
    if (!rif) return 0;
    return Math.round(rif.getBoundingClientRect().bottom + window.pageYOffset);
  }

  function aggiorna() {
    if (window.innerWidth < LARGHEZZA_MINIMA || soglia <= 0) {
      header.classList.remove('las-no-sticky');
      return;
    }
    var y = window.pageYOffset;
    var altezzaHeader = header.offsetHeight || 60;
    /* quanto va spostato in su per uscire completamente dallo schermo.
       In pixel e non in percentuale: vedi la nota in las-global-inline.liquid.
       Lo riscrivo a ogni giro perche' il tema cambia l'altezza dell'header
       mentre si scorre (.header-scrolled). +10px di margine. */
    header.style.setProperty('--las-header-h', (altezzaHeader + 10) + 'px');
    if (y > altezzaHeader && y < soglia) {
      header.classList.add('las-no-sticky');
    } else {
      header.classList.remove('las-no-sticky');
    }
  }

  function ricalcola() {
    soglia = calcolaSoglia();
    aggiorna();
  }

  ricalcola();
  window.addEventListener('scroll', aggiorna, { passive: true });
  window.addEventListener('resize', ricalcola, { passive: true });
  window.addEventListener('load', ricalcola);
  /* le immagini e i caroselli che finiscono di caricarsi cambiano l'altezza
     delle sezioni: ricalcolo la soglia anche poco dopo il caricamento */
  setTimeout(ricalcola, 1200);
  setTimeout(ricalcola, 3000);

  /* La transizione si accende solo dopo il primo posizionamento: se si apre
     la pagina gia' scrollata (ricarica a meta' pagina, o link con ancora)
     l'header deve trovarsi subito fuori schermo, non arrivarci scivolando.
     setTimeout e non requestAnimationFrame: in una scheda in secondo piano
     rAF puo' non partire mai, il timer si' (al massimo ritardato). */
  setTimeout(function () {
    header.classList.add('las-anima');
  }, 60);
})();

/* ==========================================================================
   LALTERNATIVA STYLE - Hero video: via i controlli nativi del lettore
   Aggiunto il 25/09/2026. E' un blocco a se' stante e non c'entra niente
   con l'header qui sopra: sta in questo file perche' e' l'unico gia'
   caricato sulla home che riguarda la fascia hero. Se un giorno nasce un
   file dedicato alla hero, spostalo li' tale e quale.
 
   PROBLEMA: il componente video del tema, a un certo punto dopo il
   caricamento, mette l'attributo controls sui <video> della fascia. Nell'
   HTML che arriva dal server quell'attributo NON c'e' (verificato
   scaricando la home): lo aggiunge uno script del tema, e non sempre nello
   stesso momento - a volte sul primo video, a volte sul secondo. Su Safari
   iPhone/iPad fa comparire sopra alla fascia play/pausa, i due salti da 10
   secondi, la barra di avanzamento, AirPlay e picture-in-picture, che
   restano a video qualche secondo e poi si nascondono da soli.
 
   PERCHE' IL CSS DA SOLO NON BASTAVA: nascondere ::-webkit-media-controls
   funziona su Chrome e sul Safari del Mac, ma il Safari di iPhone e iPad
   ignora quelle regole, perche' li' i controlli li disegna il sistema e non
   la pagina. La regola in theme.css resta come rete di sicurezza per gli
   altri browser; quella che risolve davvero e' questa.
 
   COSA FA: toglie l'attributo appena compare. Non una volta sola all'avvio:
   chi lo mette gira DOPO questo script e potrebbe rimetterlo a ogni cambio
   di video, quindi serve un osservatore che lo ritolga ogni volta.
   Nella hero il video e' decorativo e il clic deve andare al link della
   collezione: i controlli non devono comparire mai.
   ========================================================================== */
(function () {
  function pulisci(v) {
    if (!v || v.tagName !== 'VIDEO') return;
    if (v.hasAttribute('controls')) v.removeAttribute('controls');
    v.controls = false;
    /* gli altri si mettono una volta sola: sono attributi che nessuno
       rimette, e riscriverli a ogni giro dell'osservatore sarebbe sprecato */
    if (!v.hasAttribute('controlslist')) {
      v.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
      v.setAttribute('disableremoteplayback', '');
      v.setAttribute('x-webkit-airplay', 'deny');
      try { v.disablePictureInPicture = true; } catch (e) {}
    }
  }
 
  function avvia() {
    var fasce = document.querySelectorAll('.las-hero-video');
    if (!fasce.length) return false;
 
    for (var f = 0; f < fasce.length; f++) {
      (function (fascia) {
        function pulisciTutti() {
          var video = fascia.querySelectorAll('video');
          for (var i = 0; i < video.length; i++) pulisci(video[i]);
        }
 
        pulisciTutti();
 
        if (window.MutationObserver) {
          /* attributeFilter su controls: l'osservatore si sveglia solo per
             quell'attributo, non a ogni cambio di src o di classe durante la
             dissolvenza. Togliere un attributo che non c'e' non genera una
             nuova notifica, quindi non si innesca un ciclo infinito. */
          new MutationObserver(pulisciTutti).observe(fascia, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['controls']
          });
        } else {
          /* browser senza MutationObserver: si ricontrolla per una decina di
             secondi, che e' la finestra in cui il tema inizializza i video */
          var n = 0;
          var t = setInterval(function () {
            pulisciTutti();
            if (++n > 20) clearInterval(t);
          }, 500);
        }
      })(fasce[f]);
    }
    return true;
  }
 
  /* se lo script gira prima che la fascia esista nel documento, si riprova
     quando la pagina e' pronta */
  if (!avvia()) {
    document.addEventListener('DOMContentLoaded', avvia);
    window.addEventListener('load', avvia);
  }
})();